module.exports = __webpack_public_path__ + "static/media/debian.917a69dd.png";